package one.healthium.profile.ui.avatar.components

import androidx.compose.ui.graphics.ImageBitmap

@androidx.compose.runtime.Composable
actual fun AppImagePicker(
    showPicker: androidx.compose.runtime.MutableState<Boolean>,
    selectedImageCallback: (ImageBitmap) -> Unit,
    canDelete: Boolean,
    onDeleteImageClicked: () -> Unit
) {
    // not supported
}

actual fun ImageBitmap.toByteArray(): ByteArray? {
    return null
}